import type {MantineSize, TagsInputProps as MantineTagsInputProps} from '@mantine/core';
import {TagsInput as MantineTagsInput} from '@mantine/core';
import React from 'react';

/**
 * Free-form tag entry wrapping Mantine `TagsInput`: a user types a value and
 * presses Enter or comma to commit it as a removable pill. Value shape is `string[]`.
 * @registry Free-form tags input producing a string array, with label + helper/error text.
 */
export interface TagsInputProps {
  label?: React.ReactNode;
  ariaLabel?: string;
  value?: string[];
  name?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  error?: string;
  description?: string;
  size?: MantineSize;
  onChangeCallback: (value: string[]) => void;
  props?: MantineTagsInputProps;
}

export const TagsInput = React.memo<TagsInputProps>(
  ({
    label,
    ariaLabel,
    value,
    name,
    placeholder,
    disabled,
    required,
    error,
    description,
    size,
    onChangeCallback,
    props,
  }) => (
    <MantineTagsInput
      label={label}
      aria-label={ariaLabel}
      value={value ?? []}
      name={name}
      placeholder={placeholder}
      disabled={disabled}
      withAsterisk={required}
      error={error}
      description={description}
      size={size}
      onChange={onChangeCallback}
      clearable
      mb="sm"
      {...props}
    />
  )
);
